// this is an autogenerated file from DesignSystem/TasksViewForm/Content/Content/Actions/Action/Letter/Generate/Recipients/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_TasksViewForm_Content_Content_Actions_Action_Letter_Generate_Recipients($id: numeric!) {
  vaxiom_patients_by_pk(id: $id) {
    id
    _id
    person {
      id
      _id
      first_name
      last_name

      to_person_relationships(where: { permitted_to_see_info: { _eq: true } }) {
        id
        type
        from_person_record {
          id
          _id
          first_name
          last_name
        }
      }
    }

    professional_relationships {
      id
      dtype
      employee {
        id
        provider {
          id
          employee_resources(where: { invalid: { _eq: false } }) {
            id
            employment_contract {
              id
              person {
                id
                _id
                first_name
                last_name
              }
            }
          }
        }
      }

      other {
        id
        person {
          id
          _id
          first_name
          last_name
        }
      }
    }
  }
}

`